var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1160"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1160"
    },
    "bundlingPackage": "MeetingsPublic",
    "bundlingPackageVersion": "static-1.60166",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};